module.exports = __webpack_public_path__ + "img/telemovel.c4624500.png";